import React, { useId } from 'react';
import './loginBackdrop.css';

const TRACK = 'M-210 1070 620 675C720 626 772 540 734 475C694 408 584 419 521 476L434 554C351 630 231 579 245 471C253 403 314 358 380 327L1420-180';

/** A static racing poster, with no canvas, image downloads or animation loop. */
export default function LoginBackdrop() {
  const id = useId();
  return (
    <div className="login-static-backdrop" aria-hidden="true">
      <div className="login-static-mobile">
        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] rounded-full opacity-[0.10] blur-[80px]" style={{ background: 'var(--accent)' }} />
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] rounded-full opacity-[0.06] blur-[80px] bg-purple-500" />
        <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: 'radial-gradient(circle, var(--text-primary) 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
      </div>
      <div className="login-static-poster">
        <div className="login-static-light" />
        <svg className="login-static-track" viewBox="0 0 1600 1000" preserveAspectRatio="xMidYMid slice" fill="none" focusable="false">
          <defs>
            <linearGradient id={`${id}-edge`} x1="160" y1="840" x2="1070" y2="70" gradientUnits="userSpaceOnUse">
              <stop stopColor="#8be5bc" stopOpacity=".5" />
              <stop offset=".43" stopColor="#829fb8" stopOpacity=".15" />
              <stop offset="1" stopColor="#8be5bc" stopOpacity=".4" />
            </linearGradient>
            <linearGradient id={`${id}-asphalt`} x1="500" y1="950" x2="900" y2="0" gradientUnits="userSpaceOnUse">
              <stop stopColor="#192f39" />
              <stop offset=".52" stopColor="#182634" />
              <stop offset="1" stopColor="#132330" />
            </linearGradient>
            <pattern id={`${id}-grid`} width="80" height="80" patternUnits="userSpaceOnUse">
              <path d="M80 0H0V80" stroke="#b2c6d3" strokeOpacity=".045" />
              <path d="M38 40h4m-2-2v4" stroke="#b2c6d3" strokeOpacity=".12" />
            </pattern>
            <pattern id={`${id}-flag`} width="28" height="28" patternUnits="userSpaceOnUse">
              <path d="M0 0h14v14H0zM14 14h14v14H14z" fill="#a5c8be" fillOpacity=".075" />
            </pattern>
          </defs>
          <path d="M0 0h1600v1000H0z" fill={`url(#${id}-grid)`} />
          <g transform="translate(125 65) rotate(-8 800 500)">
            <path d={TRACK} stroke="#81d9b5" strokeOpacity=".035" strokeWidth="220" />
            <path d={TRACK} stroke={`url(#${id}-edge)`} strokeWidth="174" />
            <path d={TRACK} stroke="#10202d" strokeWidth="171" />
            <path d={TRACK} stroke="#91b8ab" strokeOpacity=".18" strokeWidth="151" strokeDasharray="8 13" />
            <path d={TRACK} stroke={`url(#${id}-asphalt)`} strokeWidth="142" />
            <path d={TRACK} stroke="#87b9a9" strokeOpacity=".15" strokeWidth="1" strokeDasharray="5 13" />
            <path d={TRACK} pathLength="100" stroke="#9ae6bd" strokeOpacity=".32" strokeWidth="2" strokeDasharray="9 91" strokeDashoffset="-18" />
          </g>
          <g stroke="#91b8ab" strokeOpacity=".2" strokeWidth="1">
            <path d="M1100 740h130m-65-65v130" />
            <circle cx="1165" cy="740" r="36" strokeDasharray="2 7" />
            <path d="M1117 740h12m72 0h12M1165 692v12m0 72v12" />
            <path d="m1210 785 100 80h180" />
          </g>
          <path d="M1330 828h224v112h-224z" fill={`url(#${id}-flag)`} transform="rotate(-8 1442 884)" />
        </svg>
        <div className="login-static-scrim" />
      </div>
    </div>
  );
}
